/** URL encoded in the equipment QR sticker. Scanning it opens this asset in admin. */
export function equipmentRecordUrl(assetNumber) {
  const url = new URL(window.location.origin);
  url.pathname = '/';
  url.searchParams.set('page', 'equipment');
  url.searchParams.set('asset', String(assetNumber || ''));
  return url.toString();
}

export function equipmentQrImageUrl(assetNumber, size = 140) {
  const data = encodeURIComponent(equipmentRecordUrl(assetNumber));
  return `https://api.qrserver.com/v1/create-qr-code/?size=${size}x${size}&data=${data}`;
}
